"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getAddressString = _interopRequireDefault(require("./getAddressString"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var makeGoogleMapLink = function makeGoogleMapLink(address) {
  return "https://www.google.com/maps/dir/?api=1&destination=".concat(encodeURIComponent((0, _getAddressString["default"])(address)));
};
var _default = exports["default"] = makeGoogleMapLink;